module finadai.services{
  import Agent = finadai.models.Agent;
  export class AgentsService {
    static instanceName = "agentsService";
    constructor(private $http: ng.IHttpService, private proxifier, private $httpParamSerializer: ng.IHttpParamSerializer){

    }
    save(data: any, id?): ng.IHttpPromise<Agent>{
      // data = this.$httpParamSerializer(data)
      if(angular.isDefined(data.id)) id = data.id
      if(angular.isUndefined(id)){
        return this.$http.post([this.proxifier(), 'finadai', 'agents'].join('/'), data);
      }
      return this.$http.put([this.proxifier(), 'finadai', 'agents', id].join('/'), data);
    }
    get(id?): ng.IHttpPromise<any>{
      if(angular.isUndefined(id)){
        return this.$http.get([this.proxifier(), 'finadai', 'agents'].join('/'), { params: { page: 1, limit: 2000 } });
      }
      return this.$http.get([this.proxifier(), 'finadai', 'agents', id].join('/'));
    }
    remove(id){
      return this.$http.delete([this.proxifier(), 'finadai', 'agents', id].join('/'));
    }
  }
}